import { filter } from 'lodash';
import { withStyles, createStyles, makeStyles } from '@material-ui/styles';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  IconButton
} from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import PageviewIcon from '@material-ui/icons/Pageview';
import axios from 'axios';
import Scrollbar from '../Scrollbar';
import SearchNotFound from '../SearchNotFound';
import { ClientListHead, ClientListToolbar } from '../_dashboard/clients';
import { useConstantsContext } from '../../context/constants_context';
import { useClientContext } from '../../context/client_context';
import { useClaimsContext } from '../../context/claims_context';
import { baseUrl } from '../../utils/constants';

const useStyles = makeStyles(() => ({
  markVerified: {
    backgroundColor: '#2979ff ',
    color: 'white'
  },
  markUnverified: {
    backgroundColor: '#ff5252',
    color: 'black'
  },
  tableFooter: {
    backgroundColor: 'black',
    color: 'white',
    size: 'small'
  }
}));

const StyledTableRow = withStyles((theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
      }
    }
  })
)(TableRow);

const TABLE_HEAD = [
  { id: 'memNo', label: 'Member #', alignRight: false },
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'group', label: 'Group', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'suffix', label: 'Suffix', alignRight: false },
  { id: 'cifno', label: 'CIF Number', alignRight: false },
  { id: 'actions', label: 'Actions', alignRight: true }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function Client() {
  const { clientList } = useConstantsContext();
  const { refreshClientValues, setDependant, setDependantList, setParentRefId } =
    useClientContext();
  const { getLimitUsage, getLimitTotalUsage, setClaimDetailsList } = useClaimsContext();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('surname');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const navigate = useNavigate();
  const classes = useStyles();
  const dept = sessionStorage.getItem('dept');

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = clientList.map((n) => n.surname);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const handleClientView = (e) => {
    console.log('row data is', e);
    refreshClientValues(e.row.cif_Number);
    openView();
  };

  const handleAdjudView = (e) => {
    console.log('row data is', e);
    getMemberInfo(e.row.membershipNo);
  };

  const getMemberInfo = async (e) => {
    await axios(`${baseUrl}/api/client/GetMembersByFundNo?medFundNo=${e.row.membershipNo}`).then(
      (result) => {
        console.log('returned members', result);
        console.log('returned members cif', result.data.result[0]);
        // setDependant(result.data.result[0]);
        setDependantList(result.data.result);
        setParentRefId(result.data.result[0].cif_number);
        getLimitUsage(result.data.result[0]);
        getLimitTotalUsage(result.data.result[0]);
        refreshClientValues(e.row.cif_Number);
        setClaimDetailsList([]);
        openAdjView();
      },
      (error) => {
        alert(`failed ${error}`);
      }
    );
  };

  const openView = () => {
    navigate('/clientportfolio/portfolios');
  };

  const openAdjView = () => {
    navigate('/claims/benefitsLookup');
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - clientList.length) : 0;

  const filteredUsers = applySortFilter(clientList, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;

  return (
    <Container>
      <Typography variant="h6" gutterBottom>
        Search Results...
      </Typography>
      <Card>
        <ClientListToolbar
          numSelected={selected.length}
          filterName={filterName}
          onFilterName={handleFilterByName}
        />

        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table size="small" aria-label="a dense table">
              <ClientListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={clientList.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
                onSelectAllClick={handleSelectAllClick}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    /* eslint-disable camelcase */
                    const { cif_Number, name, group_Name, memberStatus, suffix, membershipNo } =
                      row;
                    const isItemSelected = selected.indexOf(name) !== -1;

                    return (
                      <StyledTableRow
                        hover
                        key={cif_Number}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell padding="checkbox" />
                        <TableCell align="left">{membershipNo}</TableCell>
                        <TableCell align="left">{name}</TableCell>
                        <TableCell align="left">{group_Name}</TableCell>
                        <TableCell align="left">{memberStatus}</TableCell>
                        <TableCell align="left">{suffix}</TableCell>
                        <TableCell align="left">{cif_Number}</TableCell>

                        <TableCell align="right">
                          {(dept === '3' || dept === '5' || dept === '6') && (
                            <IconButton onClick={() => getMemberInfo({ row })}>
                              <PageviewIcon sx={{ color: '#03a9f4' }} />
                            </IconButton>
                          )}
                          {(dept === '2' || dept === '1') && (
                            <IconButton onClick={() => handleClientView({ row })}>
                              <VisibilityIcon sx={{ color: '#03a9f4' }} />
                            </IconButton>
                          )}
                        </TableCell>
                      </StyledTableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isUserNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Scrollbar>

        <TablePagination
          className={classes.tableFooter}
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={clientList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </Container>
  );
}
